import { DateHelper } from "utils/helpers";
import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";

function usePaymentSigningInformationService() {
  const getPayout = (paymentSigningInformation?: ApiModels.PaymentSigningInformation) => {
    if (paymentSigningInformation === undefined) return 0;
    let totalAmount = 0;

    paymentSigningInformation.incomingInvoices?.forEach((payout) => {
      if (payout.totalAmount) totalAmount = totalAmount + payout.totalAmount;
    });

    paymentSigningInformation.manualPayouts?.forEach((payout) => {
      if (payout.amount) totalAmount = totalAmount + payout.amount;
    });

    paymentSigningInformation.personSalaryEntries?.forEach((payout) => {
      if (payout.amount) totalAmount = totalAmount + payout.amount;
    });

    paymentSigningInformation.receipts?.forEach((payout) => {
      if (payout.amount) totalAmount = totalAmount + payout.amount;
    });

    paymentSigningInformation.salaryPayoutFileRows?.forEach((payout) => {
      if (payout.amount) totalAmount = totalAmount + payout.amount;
    });

    paymentSigningInformation.wintSalaryEntries?.forEach((payout) => {
      if (payout.amount) totalAmount = totalAmount + payout.amount;
    });

    return totalAmount;
  };

  const getDueDate = (paymentSigningInformation?: ApiModels.PaymentSigningInformation) => {
    if (paymentSigningInformation === undefined) return new Date();
    let dueDate = DateHelper.getDateMax();

    paymentSigningInformation.incomingInvoices?.forEach((payout) => {
      if (payout.payDate && DateHelper.isBefore(new Date(payout.payDate), dueDate)) dueDate = new Date(payout.payDate);
    });

    paymentSigningInformation.manualPayouts?.forEach((payout) => {
      if (payout.payoutDate && DateHelper.isBefore(new Date(payout.payoutDate), dueDate))
        dueDate = new Date(payout.payoutDate);
    });

    paymentSigningInformation.personSalaryEntries?.forEach((payout) => {
      if (payout.payoutDate && DateHelper.isBefore(new Date(payout.payoutDate), dueDate))
        dueDate = new Date(payout.payoutDate);
    });

    paymentSigningInformation.receipts?.forEach((payout) => {
      if (payout.payoutDate && DateHelper.isBefore(new Date(payout.payoutDate), dueDate))
        dueDate = new Date(payout.payoutDate);
    });

    paymentSigningInformation.salaryPayoutFileRows?.forEach((payout) => {
      if (payout.payoutDate && DateHelper.isBefore(new Date(payout.payoutDate), dueDate))
        dueDate = new Date(payout.payoutDate);
    });

    paymentSigningInformation.wintSalaryEntries?.forEach((payout) => {
      if (payout.payoutDate && DateHelper.isBefore(new Date(payout.payoutDate), dueDate))
        dueDate = new Date(payout.payoutDate);
    });

    return dueDate;
  };

  const getNumOfPayments = (paymentSigningInformation?: ApiModels.PaymentSigningInformation) => {
    if (paymentSigningInformation === undefined) return 0;

    return (
      (paymentSigningInformation.incomingInvoices?.length ?? 0) +
      (paymentSigningInformation.manualPayouts?.length ?? 0) +
      (paymentSigningInformation.personSalaryEntries?.length ?? 0) +
      (paymentSigningInformation.receipts?.length ?? 0) +
      (paymentSigningInformation.salaryPayoutFileRows?.length ?? 0) +
      (paymentSigningInformation.wintSalaryEntries?.length ?? 0)
    );
  };

  return {
    getPayout,
    getDueDate,
    getNumOfPayments,
  };
}

export default usePaymentSigningInformationService;
